<template>
  <div>
    <CommonDialog :show.sync="show" top="22vh" :show-left-icon="showLeftIcon" body-bg="#fff" :show-close-icon="showCloseIcon" :dialog-title="$t('coursesDetail.highlights')">
      <template v-slot:body>
        <div class="service-highlights-dialog">
          <div v-for="highlight in highlights" :key="highlight.id" class="highlight-item">
            <p class="highlight-title">
              {{ highlight.title }}
            </p>
            <p class="highlight-content">
              {{ highlight.content }}
            </p>
          </div>
        </div>
      </template>
    </CommonDialog>
  </div>
</template>

<script>
import CommonDialog from 'components/common/CommonDialog/index.vue';

export default {
  components: {
    CommonDialog,
  },
  props: {
    showCloseIcon: {
      default: true,
      type: Boolean,
    },
    showLeftIcon: {
      default: false,
      type: Boolean,
    },
    highlights: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    showHighlightsDialog() {
      this.show = true
    },
  },
}
</script>

<style lang="scss" scoped>
.service-highlights-dialog {
  padding: 0 24px;
  width: 512px;
  max-height: 420px;
  overflow-y: scroll;

  .highlight-item {
    margin-bottom: 20px;
    word-break: break-word;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .highlight-title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(69, 85, 113, 1);
    line-height: 24px;
    margin-bottom: 4px;
  }

  .highlight-content {
    font-size: 16px;
    font-weight: 500;
    color: rgba(162, 170, 184, 1);
    line-height: 19px;
  }
}
</style>
